export const theme = {
  dark: {
    Navbar: {
      nav: {
        background: 'black',
      },
      RRDNavLink: {
        background: 'black',
      },
      iconColor: {
        color: 'white',
      },
      textColor: {
        color: 'white',
      },
    },
    RightSide: {
      rightside: {
        background: 'black',
      },
      searchInput: {
        background: 'rgb(20, 23, 26)',
      },
      wrapperOne: {
        background: 'rgb(20, 23, 26)',
        title: {
          color: 'white',
        },
        titleTopic: {
          color: 'white',
        },
      },
      wrapperTwo: {
        background: 'black',
        accountName: {
          color: 'white',
        },
      },
    },
    links: {
      color: 'white',
    },
  },
  light: {
    Navbar: {
      nav: {
        background: 'white',
      },
      RRDNavLink: {
        background: 'white',
      },
      iconColor: {
        color: 'rgb(29,155,240)',
      },
      textColor: {
        color: 'black',
      },
    },
    RightSide: {
      rightside: {
        background: 'white',
      },
      searchInput: {
        background: 'rgb(245,245,245)',
      },
      wrapperOne: {
        background: 'rgb(247,249,249)',
        title: {
          color: 'black',
        },
        titleTopic: {
          color: 'black',
        },
      },
      wrapperTwo: {
        background: 'white',
        accountName: {
          color: 'black',
        },
      },
    },
    links: {
      color: 'black',
    },
  },
};
